import { render } from "./OcrPlotlyChart.vue?vue&type=template&id=66c2882c"
import script from "./OcrPlotlyChart.vue?vue&type=script&lang=js"
export * from "./OcrPlotlyChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__